import { ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';

export class TokenHelper {
	public static getToken(activatedRoute: ActivatedRoute): string {
		return activatedRoute.snapshot.paramMap.get('token');
	}	
}
